<span class="fdk-logo">
  <img
    class="fdk-logo__image fdk-logo__image--light"
    src="assets/logos/fasten-light.svg"
    [attr.alt]="ariaLabel" />
  <img
    class="fdk-logo__image fdk-logo__image--dark"
    src="assets/logos/fasten-dark.svg"
    [attr.alt]="ariaLabel" />
</span>
